export default __webpack_public_path__ + "static/media/01-home-min.f5d8a884.png";